import { Col, Divider, Row, Typography } from "antd";
import CheckIcon from "remixicon-react/CheckFillIcon";
import VideoIcon from "remixicon-react/YoutubeFillIcon";
import styles from "./InstructionHintContent.module.css";
import { iconSize } from "../../config";
import { ActionListItem } from "./ActionListItem";
import Target from "remixicon-react/Focus3LineIcon";
import { ReactComponent as HandGrabbing } from "../../assets/icons/HandGrabbing.svg";
import { ReactComponent as ArrowEllipse } from "../../assets/icons/ArrowEllipse.svg";
import EyeIcon from "remixicon-react/EyeLineIcon";
import { ReactComponent as SpinIcon } from "../../assets/icons/spin.svg";
import { useDispatch } from "react-redux";
import { setCurrentlyOpenModal } from "../../redux";
import { modals } from "../../util/constants";
import { setAutoHint } from "../../redux/ui/ui";
import clsx from "clsx";

const { Link } = Typography;

const StepListItem = ({ icon, title, description }) => {
  return (
    <Row>
      <Col span={3}>
        <div className={styles.center}>{icon}</div>
      </Col>
      <Col span={21}>
        <p>
          <strong>{title}</strong>
          <br />
          {description}
        </p>
      </Col>
    </Row>
  );
};

const CheckNumber = ({ number, checked = false }) => {
  return checked ? (
    <div className={clsx(styles.checkNumber, styles.check)}>
      <CheckIcon size={iconSize} />
    </div>
  ) : (
    <div className={clsx(styles.checkNumber, styles.number)}> {number} </div>
  );
};

const Footer = () => {
  const dispatch = useDispatch();
  return (
    <>
      <Divider />
      <div className={styles.list}>
        <div className={styles.center}>
          <Link
            style={{ marginLeft: `-${iconSize}px` }}
            onClick={() =>
              dispatch(setCurrentlyOpenModal(modals.videoTutorial))
            }
          >
            <VideoIcon
              size={iconSize}
              style={{ transform: "translate(-3px,3px)" }}
            />{" "}
            Watch tutorial video
          </Link>
        </div>
        <div className={styles.center}>
          <Link
            onClick={() => dispatch(setAutoHint(false))}
            style={{ color: "var(--secondaryColor, #7e7e7e)" }}
          >
            Hide these hints?
          </Link>
        </div>
      </div>
    </>
  );
};

export function InstructionHintContent({ stage }) {
  let content;
  switch (stage) {
    case "done":
      content = (
        <>
          <p>The hotspot path has been calculated.</p>
          <p>Now you can refine it: </p>
          <div className={styles.list}>
            <ActionListItem
              icon={<ArrowEllipse />}
              description={"Drag the spin to check the path."}
            />
            <ActionListItem
              icon={<Target size={iconSize} />}
              description={
                "Click and drag hotspot marker to adjust its location."
              }
            />
            <ActionListItem
              icon={<EyeIcon size={iconSize} />}
              description={
                "Show/hide a hotspot per frame by clicking its marker or the Eye toolbar icon."
              }
            />
            <ActionListItem
              icon={<SpinIcon />}
              description={
                "Disable snapping to separately adjust each frame's hotspot position if needed."
              }
            />
            <ActionListItem
              icon={<CheckIcon size={iconSize} />}
              description={
                "Click Done once the hotspot path looks good. You can adjust it later."
              }
            />
          </div>
          <Footer />
        </>
      );
      break;
    case "manual":
      content = (
        <>
          <ActionListItem
            icon={<SpinIcon />}
            description={"Enable snapping for automatic placement."}
          />
        </>
      );
      break;
    default:
      content = (
        <>
          <p style={{ marginBlockEnd: "16px" }}>
            The whole hotspot path will be calculated after you mark its
            position on 3 frames:
          </p>
          <div className={styles.list}>
            <StepListItem
              icon={<CheckNumber number={1} checked={stage >= 1} />}
              title="First frame seen"
              description="Where the hotspot first appears"
            />
            <StepListItem
              icon={<CheckNumber number={2} checked={stage >= 2} />}
              title="Halfway frame"
              description="A frame in the middle of the range"
            />
            <StepListItem
              icon={<CheckNumber number={3} checked={stage >= 3} />}
              title="Final frame"
              description="The frame just before the hotspot disappears from view"
            />
          </div>
          <Divider />
          <div className={styles.list}>
            <ActionListItem
              icon={<ArrowEllipse />}
              description="Drag the spin to rotate it"
            />
            <ActionListItem
              icon={<Target size={iconSize} />}
              description="Click on spin to place a hotspot"
            />
            <ActionListItem
              icon={<HandGrabbing />}
              description="Drag hotspot to adjust its position"
            />
          </div>
          <Footer />
        </>
      );
      break;
  }
  return <div className={styles.container}>{content}</div>;
}
